<mf-row>
  <mf-field-numeric
    [label]="gridFilter.header"
    [decimals]="gridFilter.intOnly ? 0 : 2"
    [allowNulls]="true"
    [(ngModel)]="value" />
</mf-row>
